import React from 'react';
import { Link } from "react-router-dom";
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		border: '1px solid #C8CCD1'
	},
	cardTitleText: {
		marginTop: 30,
		marginBottom: 20,
		color: '#333333',
		fontFamily: 'Graphik',
		fontSize: 24,
		fontWeight: 600,
		letterSpacing: 0
	},
	cardText: {
		marginBottom: 40,
		fontSize: 16,
		color: '#333333',
	},
	anchorText: {
		color: '#005383',
		fontWeight: 600,
	}
});

const MemberNotFoundCard = () => {
	const classes = useStyles();

	return (
		<Card className={classes.root} variant="outlined">
			<div className={classes.cardTitleText}>
				Member Not Found
			</div>
			<div className={classes.cardText}>
				This person is a former member of Congress and does not serve in the current Congress. 
				<p/>You can find the member’s successor by using our <Link to="/">search functionality.</Link>
			</div>
		</Card>
	);
}

export default MemberNotFoundCard;